import React from 'react'
import { connectStats } from 'react-instantsearch-dom'

import Button from '../../atoms/Button/Button'

const ShowApartmentButtons = ({ nbHits, processingTimeMS, ...props }) => (
  <Button {...props}>Show {nbHits} apartments</Button>
)

export default connectStats(ShowApartmentButtons)
